// src/i18n/locales/id.js

export default {
  countries: {
    'AF': 'Afganistan',
    'AL': 'Albania',
    'DZ': 'Aljazair',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AG': 'Antigua dan Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahama',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgia',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia dan Herzegovina',
    'BW': 'Botswana',
    'BR': 'Brasil',
    'BN': 'Brunei',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Tanjung Verde',
    'KH': 'Kamboja',
    'CM': 'Kamerun',
    'CA': 'Kanada',
    'CF': 'Republik Afrika Tengah',
    'TD': 'Chad',
    'CL': 'Chili',
    'CN': 'Tiongkok',
    'CO': 'Kolombia',
    'KM': 'Komoro',
    'CG': 'Kongo',
    'CD': 'Republik Demokratik Kongo',
    'CR': 'Kosta Rika',
    'CI': 'Pantai Gading',
    'HR': 'Kroasia',
    'CU': 'Kuba',
    'CY': 'Siprus',
    'CZ': 'Ceko',
    'DK': 'Denmark',
    'DJ': 'Jibuti',
    'DM': 'Dominika',
    'DO': 'Republik Dominika',
    'EC': 'Ekuador',
    'EG': 'Mesir',
    'SV': 'El Salvador',
    'GQ': 'Guinea Khatulistiwa',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Etiopia',
    'FJ': 'Fiji',
    'FI': 'Finlandia',
    'FR': 'Prancis',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Jerman',
    'GH': 'Ghana',
    'GR': 'Yunani',
    'GD': 'Grenada',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HN': 'Honduras',
    'HU': 'Hungaria',
    'IS': 'Islandia',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran',
    'IQ': 'Irak',
    'IE': 'Irlandia',
    'IL': 'Israel',
    'IT': 'Italia',
    'JM': 'Jamaika',
    'JP': 'Jepang',
    'JO': 'Yordania',
    'KZ': 'Kazakstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'Korea Utara',
    'KR': 'Korea Selatan',
    'KW': 'Kuwait',
    'KG': 'Kirgizstan',
    'LA': 'Laos',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lituania',
    'LU': 'Luksemburg',
    'MG': 'Madagaskar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maladewa',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Kepulauan Marshall',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'MX': 'Meksiko',
    'FM': 'Mikronesia',
    'MD': 'Moldova',
    'MC': 'Monako',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MA': 'Maroko',
    'MZ': 'Mozambik',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Belanda',
    'NZ': 'Selandia Baru',
    'NI': 'Nikaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'MK': 'Makedonia Utara',
    'NO': 'Norwegia',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestina',
    'PA': 'Panama',
    'PG': 'Papua Nugini',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Filipina',
    'PL': 'Polandia',
    'PT': 'Portugal',
    'QA': 'Qatar',
    'RO': 'Rumania',
    'RU': 'Rusia',
    'RW': 'Rwanda',
    'KN': 'Saint Kitts dan Nevis',
    'LC': 'Saint Lucia',
    'VC': 'Saint Vincent dan Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome dan Principe',
    'SA': 'Arab Saudi',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapura',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Kepulauan Solomon',
    'SO': 'Somalia',
    'ZA': 'Afrika Selatan',
    'SS': 'Sudan Selatan',
    'ES': 'Spanyol',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SZ': 'Eswatini',
    'SE': 'Swedia',
    'CH': 'Swiss',
    'SY': 'Suriah',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad dan Tobago',
    'TN': 'Tunisia',
    'TR': 'Turki',
    'TM': 'Turkmenistan',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraina',
    'AE': 'Uni Emirat Arab',
    'GB': 'Britania Raya',
    'US': 'Amerika Serikat',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VA': 'Kota Vatikan',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'YE': 'Yaman',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
  },
  verification: {
    verifying: 'Memverifikasi email Anda...',
    success: 'Email Berhasil Diverifikasi!',
    failed: 'Verifikasi Gagal',
    accountVerified: 'Akun Anda telah berhasil diverifikasi. Sekarang Anda dapat masuk ke akun Anda.',
    invalidLink: 'Tautan verifikasi tidak valid atau telah kedaluwarsa.',
    missingToken: 'Token verifikasi tidak ditemukan.',
    generalError: 'Terjadi kesalahan saat verifikasi. Silakan coba lagi nanti.',
    proceedToLogin: 'Lanjutkan ke Login',
    backToLogin: 'Kembali ke Login'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Dasbor',
    system: 'Sistem',
    settings: 'Pengaturan',
    overview: 'Ikhtisar',
    database: 'Database',
    logs: 'Log',
    userManagement: 'Manajemen Pengguna',
    security: 'Keamanan',
    systemAdministration: 'Administrasi Sistem',
    loading: 'Memuat...',
    close: 'Tutup dasbor',
    edit: 'Ubah',
    systemUptime: 'Waktu Aktif Sistem',
    avgResponseTime: 'Waktu Respon Rata-rata',
    errorRate: 'Tingkat Kesalahan',
    activeUsers: 'Pengguna Aktif',
    monthlyActiveUsers: 'Pengguna Aktif Bulanan (MAU)',
    fromLastMonth: 'dari bulan lalu',
    today: 'Hari Ini',
    tabs: {
      overview: 'Kesehatan Sistem',
      hierarchy: 'Hierarki Pengetahuan', // NEW
      documents: 'Manajemen Dokumen', // NEW
      database: 'Database',
      logs: 'Log',
      security: 'Keamanan',
      users: 'Pengguna'
    },
    // --- NEW KEYS ---
    contentManagement: "MANAJEMEN KONTEN",
    knowledgeHierarchy: "Hierarki Pengetahuan",
    documentManagement: "Manajemen Dokumen",
    noLogsFound: "Tidak ada log yang ditemukan hari ini",
    invalidLogsResponse: "Struktur respons ringkasan log tidak valid",
    logsSummaryError: "Gagal memuat ringkasan log",
    buttons: {
      save: "Simpan",
      cancel: "Batal",
      switch: "Tetap Pindahkan",
      discard: "Buang"
    },
    confirm: {
      defaultTitle: "Konfirmasi",
      defaultMessage: "Apakah Anda yakin?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'Status Kesehatan Sistem',
    runDiagnostics: 'Jalankan Diagnostik',
    resourceUsage: 'Penggunaan Sumber Daya',
    services: {
      apiServices: 'Layanan API',
      database: 'Database',
      cache: 'Cache',
      storage: 'Penyimpanan',
      messageQueue: 'Antrian Pesan',
      externalApi: 'API Eksternal'
    },
    resources: {
      cpu: 'Penggunaan CPU',
      memory: 'Penggunaan Memori',
      storage: 'Penggunaan Penyimpanan',
      network: 'Bandwidth Jaringan'
    },
    databaseManagement: 'Manajemen Database',
    reindexDatabase: 'Indeks Ulang Database',
    lastReindex: 'Indeks Ulang Terakhir',
    databaseSize: 'Ukuran Database',
    totalTables: 'Total Tabel',
    logManagement: 'Manajemen Log',
    rolloverLogs: 'Rollover Log',
    searchLogs: 'Cari Log',
    logTime: 'Waktu',
    logLevel: 'Level',
    logService: 'Layanan',
    logMessage: 'Pesan',
    showingEntries: 'Menampilkan {start}-{end} dari {total} entri',
    logLevels: {
      error: 'ERROR',
      warn: 'PERINGATAN',
      info: 'INFO',
      debug: 'DEBUG'
    },
    logMessages: {
      connectionTimeout: 'Waktu koneksi ke penyedia eksternal habis',
      lowDiskSpace: 'Ruang disk di bawah ambang batas 10%',
      userRoleUpdated: 'Peran pengguna diperbarui untuk admin@huduma.ai'
    },
    userName: 'Nama',
    userEmail: 'Email',
    userRole: 'Peran',
    userStatus: 'Status',
    userActions: 'Tindakan',
    roleAdministrator: 'Administrator',
    roleUser: 'Pengguna',
    statusActive: 'Aktif',
    dbActions: {
      reindex: 'Indeks Ulang',
      backup: 'Cadangkan',
      optimize: 'Optimalkan',
      reindexDesc: 'Bangun ulang indeks database',
      backupDesc: 'Buat cadangan database',
      optimizeDesc: 'Optimalkan kinerja query'
    },
    operations: {
      reindexTitle: 'Hasil Indeks Ulang Database',
      backupTitle: 'Hasil Cadangan Database',
      optimizeTitle: 'Hasil Optimasi Database',
      reindexResults: 'Hasil Indeks Ulang',
      optimizeResults: 'Hasil Optimasi',
      collection: 'Koleksi',
      status: 'Status',
      indexSuggestions: 'Saran Indeks',
      backupDetails: 'Detail Cadangan',
      backupFile: 'File Cadangan',
      backupLocation: 'Lokasi',
      backupSize: 'Ukuran',
      errorDetails: 'Detail Kesalahan',
      close: 'Tutup',
      resultsTitle: 'Hasil Operasi',
      reindexDatabase: {
        success: 'Indeks ulang database berhasil diselesaikan',
        error: 'Kesalahan saat indeks ulang database',
        loading: 'Mengindeks ulang database...'
      },
      backupDatabase: {
        success: 'Pencadangan database berhasil diselesaikan',
        error: 'Kesalahan saat pencadangan database',
        loading: 'Mencadangkan database...'
      },
      optimizeDatabase: {
        success: 'Optimasi database berhasil diselesaikan',
        error: 'Kesalahan saat optimasi database',
        loading: 'Mengoptimalkan database...'
      },
      rolloverLogs: {
        success: 'Rollover log berhasil diselesaikan',
        loading: 'Melakukan rollover log...'
      },
      searchLogs: {
        success: 'Pencarian log selesai',
        loading: 'Mencari log...'
      },
      runDiagnostics: {
        success: 'Diagnostik berhasil diselesaikan',
        loading: 'Menjalankan diagnostik...'
      },
      runSecurityScan: {
        success: 'Pemindaian keamanan berhasil diselesaikan',
        loading: 'Menjalankan pemindaian keamanan...'
      },
      cancel: 'Batal',
      save: 'Simpan Perubahan'
    },
    userManagementSection: {
      totalUsers: 'Total Pengguna',
      newUsers: 'Pengguna Baru (Bulan)',
      searchUsers: 'Cari pengguna...',
      clearSearch: 'Hapus pencarian',
      search: 'Cari',
      usersFound: 'pengguna ditemukan',
      showAllUsers: 'Tampilkan Semua Pengguna',
      searching: 'Mencari...',
      searchingUsers: 'Mencari pengguna...',
      noUsersFound: 'Tidak ada pengguna yang cocok dengan kriteria pencarian Anda.',
      noUsers: 'Tidak ada pengguna yang tersedia.',
      showing: 'Menampilkan',
      of: 'dari',
      previous: 'Sebelumnya',
      next: 'Berikutnya',
      searchFields: {
        all: 'Semua Bidang',
        name: 'Nama',
        email: 'Email',
        role: 'Peran'
      },
      userSearch: {
        resultsFound: 'Ditemukan {total} pengguna yang cocok dengan "{term}"',
        error: 'Kesalahan mencari pengguna'
      }
    },
    logsSection: {
      errorLogs: 'Log Kesalahan',
      warningLogs: 'Log Peringatan',
      noErrorLogs: 'Tidak ada log kesalahan yang tercatat hari ini.',
      noWarningLogs: 'Tidak ada log peringatan yang tercatat hari ini.',
      infoLogsNote: 'Log info tidak ditampilkan dalam ringkasan. Gunakan fungsi pencarian untuk melihat semua jenis log.',
      searchResults: 'Hasil Pencarian Terbaru',
      entriesFound: 'entri ditemukan',
      viewAllResults: 'Lihat Semua Hasil',
      logType: 'Jenis',
      logCount: 'Jumlah',
      logTypes: {
        connectionTimeout: 'Waktu koneksi habis',
        databaseFailed: 'Query database gagal',
        authFailed: 'Otentikasi gagal',
        lowDiskSpace: 'Ruang disk di bawah ambang batas',
        slowQuery: 'Kinerja query lambat',
        rateLimit: 'Batas laju mendekat'
      },
      logSearch: {
        noResultsFound: 'Tidak ada log yang cocok dengan kriteria pencarian Anda',
        resultsFound: 'Ditemukan {count} entri log'
      }
    },
    security: {
      title: 'Pemantauan Keamanan',
      securityScan: 'Pemindaian Keamanan',
      runningSecurityScan: 'Menjalankan Pemindaian...',
      lastSecurityScan: 'Pemindaian Keamanan Terakhir',
      vulnerabilitiesFound: 'Kerentanan Ditemukan',
      daysAgo: 'hari yang lalu',
      critical: 'kritis',
      medium: 'sedang',
      low: 'rendah',
      failedLoginAttempts: 'Upaya Login Gagal (24 jam)',
      suspiciousActivities: 'Aktivitas Mencurigakan (24 jam)',
      securityRecommendations: 'Rekomendasi Keamanan',
      criticalVulnerabilities: 'Kerentanan Kritis',
      mediumVulnerabilities: 'Kerentanan Sedang',
      lowVulnerabilities: 'Kerentanan Rendah',
      authenticationIssues: 'Masalah Otentikasi',
      suspiciousActivityLogs: 'Log Aktivitas Mencurigakan',
      securityProbeAttempts: 'Upaya Penyelidikan Keamanan Terdeteksi',
      sensitiveFileAccess: 'upaya untuk mengakses file sensitif atau endpoint terdeteksi',
      envFileAccess: 'Upaya Akses File Lingkungan',
      envFileAccessDesc: 'upaya untuk mengakses file .env terdeteksi',
      gitRepoAccess: 'Upaya Akses Repositori Git',
      gitRepoAccessDesc: 'upaya untuk mengakses file repositori .git terdeteksi',
      recommendedAction: 'Tindakan yang Direkomendasikan',
      rateLimitRecommendation: 'Pertimbangkan untuk menerapkan pembatasan laju, pemblokiran IP untuk pelanggar berulang, dan pastikan pengerasan server yang tepat telah dilakukan.',
      envFileRecommendation: 'Pastikan file lingkungan tidak dapat diakses dari direktori web dan konfigurasi server memblokir akses ke file sensitif dengan benar.',
      gitRepoRecommendation: 'Pastikan direktori .git diamankan dengan benar dan tidak dapat diakses dari web.',
      noVulnerabilitiesFound: 'Tidak Ada Kerentanan Ditemukan',
      systemSecure: 'Sistem Anda tampaknya aman. Lanjutkan pemantauan secara teratur.',
      loadingScan: 'Memuat hasil pemindaian...',
      occurrences: 'Kejadian',
      firstSeen: 'Pertama Dilihat',
      lastSeen: 'Terakhir Dilihat',
      timestamp: 'Cap Waktu',
      message: 'Pesan',
      service: 'Layanan',
      type: 'Jenis',
      severity: 'Tingkat Keparahan',
      url: 'URL',
      matchedTerm: 'Istilah yang Cocok',
      lineNumber: 'Nomor Baris',
      lineNumbers: 'Nomor Baris',
      showLess: 'Tampilkan Lebih Sedikit',
      showMore: 'Tampilkan Semua Masalah',
      // --- NEW KEY ---
      lastScanJustNow: "Baru saja"
    },
    userEdit: {
      title: 'Ubah Pengguna',
      loading: 'Memuat data pengguna...',
      userInfo: 'Informasi Pengguna',
      userId: 'ID Pengguna',
      loginName: 'Nama Login',
      fullName: 'Nama Lengkap',
      dob: 'Tanggal Lahir',
      email: 'Email',
      emailVerified: 'Email Terverifikasi',
      verified: 'Terverifikasi',
      notVerified: 'Belum Diverifikasi',
      createdAt: 'Dibuat',
      lastLogin: 'Login Terakhir',
      never: 'Tidak Pernah',
      accountSettings: 'Pengaturan Akun',
      accountStatus: 'Status Akun',
      accountEnabled: 'Akun Diaktifkan',
      cannotDisableSelf: 'Anda tidak dapat menonaktifkan akun Anda sendiri',
      accountRole: 'Peran Akun',
      adminRole: 'Peran Admin',
      cannotChangeOwnRole: 'Anda tidak dapat mengubah peran Anda sendiri',
      adminActions: 'Tindakan Admin',
      verifyEmail: 'Verifikasi Email',
      resetPassword: 'Kirim Atur Ulang Kata Sandi',
      forceLogout: 'Paksa Logout',
      failedToLoad: 'Gagal memuat data pengguna',
      errorLoading: 'Kesalahan memuat data pengguna',
      saveSuccess: 'Pengaturan pengguna berhasil diperbarui',
      errorSaving: 'Kesalahan menyimpan pengaturan pengguna',
      verifyEmailSuccess: 'Email verifikasi berhasil dikirim',
      emailVerificationFailed: 'Gagal mengirim email verifikasi',
      errorVerifyingEmail: 'Kesalahan mengirim email verifikasi',
      passwordResetSent: 'Email atur ulang kata sandi telah dikirim',
      passwordResetFailed: 'Gagal mengirim atur ulang kata sandi',
      errorSendingReset: 'Kesalahan mengirim atur ulang kata sandi',
      logoutForced: 'Pengguna telah logout',
      logoutFailed: 'Gagal memaksa logout',
      errorForcingLogout: 'Kesalahan memaksa logout',
      // --- NEW KEY ---
      userUpdated: "Pengguna berhasil diperbarui"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "Manajemen Hierarki Pengetahuan (catatan: selalu dalam Bahasa Inggris - tambahkan terjemahan)",
      addCategory: "Tambah Kategori Baru",
      loading: "Memuat Hierarki...",
      addService: "Tambah Layanan",
      editCategory: "Ubah Kategori",
      deleteCategory: "Hapus Kategori",
      editService: "Ubah Layanan",
      deleteService: "Hapus Layanan",
      empty: 'Tidak ada kategori ditemukan. Klik "Tambah Kategori Baru" untuk memulai.',
      formTitleCreateCategory: "Buat Kategori Baru",
      formTitleAddService: 'Tambah Layanan ke "{categoryName}"',
      formTitleEditCategory: 'Ubah Kategori: "{itemName}"',
      formTitleEditService: 'Ubah Layanan: "{itemName}"',
      nameEnLabel: "Nama (Inggris)",
      translationsTitle: "Terjemahan untuk Tampilan",
      loadingTranslations: "Memuat terjemahan...",
      selectLang: "Pilih Bahasa",
      translationPlaceholder: "Masukkan terjemahan",
      deleteTranslation: "Hapus Terjemahan",
      addTranslation: "+ Tambah Terjemahan",
      saveSuccess: "Item hierarki berhasil disimpan.",
      saveError: "Gagal menyimpan item hierarki.",
      loadError: "Gagal memuat hierarki pengetahuan.",
      loadTranslationsError: "Gagal memuat terjemahan.",
      confirmCancelTitle: "Perubahan Belum Disimpan",
      confirmCancelEdit: "Anda memiliki perubahan yang belum disimpan yang akan hilang. Apakah Anda yakin ingin pindah tab?",
      confirmDeleteTitleCategory: "Hapus Kategori?",
      confirmDeleteTitleService: "Hapus Layanan?",
      confirmDeleteCategory: 'Apakah Anda yakin ingin menghapus Kategori "{itemName}"? Tindakan ini tidak dapat dibatalkan.',
      confirmDeleteService: 'Apakah Anda yakin ingin menghapus Layanan "{itemName}"? Tindakan ini tidak dapat dibatalkan.',
      deleteSuccessCategory: "Kategori berhasil dihapus.",
      deleteSuccessService: "Layanan berhasil dihapus.",
      deleteErrorCategory: "Gagal menghapus Kategori.",
      deleteErrorService: "Gagal menghapus Layanan.",
      duplicateLangError: "Ditemukan bahasa duplikat dalam terjemahan. Harap hapus."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "Manajemen Dokumen",
      addLink: "Tambah dari Tautan",
      uploadFiles: "Unggah File",
      searchPlaceholder: "Cari berdasarkan nama file...",
      allStatuses: "Semua Status",
      statusPending: "Tertunda",
      statusIngested: "Terserap",
      statusRetracted: "Ditarik",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "Sedang Diproses",
      statusError: "Kesalahan Pemrosesan",
      statusWarning: "Terserap dengan Peringatan",
      // ---
      ingestSelected: "Proses Pilihan",
      colFileName: "Nama File",
      colStatus: "Status",
      colLabels: "Label",
      colUploadDate: "Tanggal Unggah",
      colSize: "Ukuran",
      loading: "Memuat dokumen...",
      empty: "Tidak ada dokumen ditemukan.",
      loadError: "Gagal memuat dokumen.",
      confirmIngestTitle: "Konfirmasi Pemrosesan Batch",
      ingest: "Proses",
      confirmIngestSelected: "Apakah Anda yakin ingin memproses {count} file yang dipilih?",
      ingestQueuedSuccess: "{count} file telah dimasukkan ke antrian untuk diproses.",
      ingestQueuedError: "Terjadi kesalahan selama proses pemrosesan batch.",
      uploadSuccessMultiple: "{count} file berhasil diunggah.",
      linkSubmitSuccess: 'Berhasil merayapi dan menyimpan "{fileName}".',
      actionSuccess: 'Tindakan "{action}" pada file {fileId} berhasil.',
      metadataUpdateSuccess: "Metadata untuk file {fileId} telah diperbarui."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Buat Kata Sandi Baru',
    tokenLabel: 'Token Atur Ulang',
    tokenPlaceholder: 'Masukkan token atur ulang',
    validateButton: 'Validasi Token',
    newPasswordLabel: 'Kata Sandi Baru',
    newPasswordPlaceholder: 'Buat kata sandi baru',
    confirmNewPasswordLabel: 'Konfirmasi Kata Sandi Baru',
    confirmNewPasswordPlaceholder: 'Konfirmasi kata sandi baru Anda',
    resetButton: 'Atur Ulang Kata Sandi',
    processing: 'Mengatur ulang...',
    rememberedPassword: 'Ingat kata sandi Anda?',
    backToLogin: 'Kembali ke Login',
    supportMessage: 'Butuh bantuan? Hubungi tim dukungan kami',
    passwordRequirements: 'Kata sandi harus minimal 8 karakter dengan setidaknya 1 angka, 1 huruf besar, dan 1 karakter khusus',
    passwordsDoNotMatch: 'Kata sandi tidak cocok',
    resetSuccess: 'Kata sandi Anda telah berhasil diatur ulang',
    resetFailed: 'Tidak dapat mengatur ulang kata sandi. Silakan coba lagi.',
    noTokenProvided: 'Harap berikan token atur ulang',
    expiredToken: 'Token atur ulang ini telah kedaluwarsa. Silakan minta yang baru.',
    invalidToken: 'Token atur ulang tidak valid atau tidak dikenal',
    validatingToken: 'Memvalidasi token...',
    redirecting: 'Mengarahkan ke halaman login...',
    passwordStrength: 'Kekuatan Kata Sandi',
    strengthLabels: {
      veryWeak: 'Sangat Lemah',
      weak: 'Lemah',
      fair: 'Cukup',
      good: 'Baik',
      strong: 'Kuat'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Gunakan setidaknya 8 karakter',
      addUppercase: 'Tambahkan huruf besar',
      addLowercase: 'Tambahkan huruf kecil',
      addNumbers: 'Tambahkan angka',
      addSpecialChars: 'Tambahkan karakter khusus'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Atur Ulang Kata Sandi Anda',
    emailLabel: 'Alamat Email',
    emailPlaceholder: 'Masukkan email Anda',
    resetButton: 'Kirim Tautan Atur Ulang',
    processing: 'Mengirim...',
    rememberPassword: 'Ingat kata sandi Anda?',
    backToLogin: 'Kembali ke Login',
    supportMessage: 'Butuh bantuan? Hubungi tim dukungan kami',
    invalidEmail: 'Harap masukkan alamat email yang valid',
    resetRequestSuccess: 'Tautan atur ulang kata sandi telah dikirim ke email Anda',
    resetRequestFailed: 'Tidak dapat mengirim tautan atur ulang kata sandi. Silakan coba lagi.',
    checkEmail: 'Silakan periksa email Anda untuk instruksi lebih lanjut.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Buat Akun Baru",
    username: "Nama Pengguna",
    usernamePlaceholder: "Masukkan nama pengguna",
    email: "Email",
    emailPlaceholder: "Masukkan email Anda",
    password: "Kata Sandi",
    passwordPlaceholder: "Buat kata sandi",
    confirmPassword: "Konfirmasi Kata Sandi",
    confirmPasswordPlaceholder: "Konfirmasi kata sandi Anda",
    acceptTerms: "Saya menerima",
    termsOfService: "Ketentuan Layanan",
    registerButton: "Buat Akun",
    processing: "Memproses...",
    alreadyHaveAccount: "Sudah punya akun?",
    loginNow: "Masuk",
    privacyNotice: "Dengan mendaftar, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi kami",
    usernameMinLength: "Nama pengguna harus minimal 3 karakter",
    invalidEmail: "Harap masukkan alamat email yang valid",
    passwordRequirements: "Kata sandi harus minimal 8 karakter dengan setidaknya 1 angka dan 1 huruf besar",
    passwordsDoNotMatch: "Kata sandi tidak cocok",
    mustAcceptTerms: "Anda harus menerima Ketentuan Layanan",
    registrationFailed: "Pendaftaran gagal. Silakan coba lagi.",
    usernameExists: "Nama pengguna sudah ada",
    emailExists: "Email sudah ada",
    registrationSuccess: "Pendaftaran Berhasil!",
    verificationEmailSent: "Email verifikasi telah dikirim ke {email}",
    checkEmailInstructions: "Silakan periksa email Anda dan ikuti instruksi untuk memverifikasi akun Anda sebelum masuk.",
    backToLogin: "Kembali ke Login",
    noEmailReceived: "Tidak menerima email?",
    resendVerification: "Kirim ulang email verifikasi",
    verificationResent: "Email verifikasi telah dikirim ulang",
    verificationResendFailed: "Gagal mengirim ulang email verifikasi. Silakan coba lagi.",
    usernameInvalidChars: 'Nama pengguna hanya dapat berisi huruf, angka, garis bawah, titik, dan tanda hubung',
    networkError: 'Kesalahan jaringan. Silakan periksa koneksi Anda dan coba lagi.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Nama Pengguna',
    password: 'Kata Sandi',
    loginButton: 'Masuk',
    or: 'atau',
    savedAccounts: 'Akun Tersimpan',
    loginSuccess: 'Login berhasil',
    loginError: 'Login gagal. Silakan periksa kredensial Anda.',
    googleLogin: 'Lanjutkan dengan Google',
    facebookLogin: 'Lanjutkan dengan Facebook',
    rememberMe: 'Ingat saya',
    forgotPassword: 'Lupa kata sandi?',
    noAccount: 'Belum punya akun?',
    createAccount: 'Buat akun',
    registerNow: "Daftar sekarang",
    termsAndPolicy: 'Dengan masuk, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi kami',
    loggingIn: "Masuk...",
    fieldsRequired: "Nama pengguna dan kata sandi diperlukan",
    invalidCredentials: "Nama pengguna atau kata sandi tidak valid",
    tooManyAttempts: "Terlalu banyak upaya login. Silakan coba lagi nanti.",
    loginFailed: "Login gagal. Silakan coba lagi.",
    oauthNotImplemented: "Login sosial belum diimplementasikan",
    savedLoginNotImplemented: "Login akun tersimpan belum diimplementasikan"
  },
  charts: {
    tooltip: {
      title: 'Tanggal',
      totalQueries: 'Total Pertanyaan',
      uniqueUsers: 'Pengguna Unik'
    },
    day: 'Hari',
    noData: 'Tidak Ada Data',
    notAvailable: 'T/A',
    topQueries: 'Pertanyaan Teratas',
    categoryDistribution: 'Penggunaan Area Pengetahuan',
    usageTrend: 'Tren Penggunaan'
  },
  analytics: {
    title: 'Analitik Data & Wawasan',
    loading: 'Memuat data analitik...',
    period: 'Periode Waktu',
    charts: {
      satisfactionHeatmap: "Kepuasan berdasarkan Area Pengetahuan",
      satisfactionSubtitle: "Skor persentase dari waktu ke waktu"
    },
    timePeriods: {
      week4: "4 Minggu Lalu",
      week3: "3 Minggu Lalu",
      week2: "2 Minggu Lalu",
      week1: "Minggu Lalu",
      current: "Saat Ini"
    },
    errors: {
      loading: "Gagal memuat data analitik. Silakan coba lagi.",
    },
    status: {
      loading: 'Memuat...',
      noData: 'Tidak ada data yang tersedia untuk periode ini',
      error: 'Gagal memuat data analitik',
      online: "Sistem Online",
      offline: "Sistem Offline",
      responseTime: "Waktu Respon Rata-rata",
      queueLength: "Antrian",
      uptime: "Waktu Aktif"
    },
    periods: {
      daily: 'Harian',
      weekly: 'Mingguan',
      monthly: 'Bulanan',
      allTime: 'Semua Waktu'
    },
    metrics: {
      totalQueries: 'Total Pertanyaan',
      uniqueUsers: 'Pengguna Unik',
      avgResponseTime: 'Waktu Respon Rata-rata',
      satisfaction: 'Kepuasan Pengguna'
    },
    table: {
      rank: 'Peringkat',
      query: 'Pertanyaan',
      count: 'Jumlah',
      avgTime: 'Waktu Rata-rata'
    },
    chartLabels: {
      categories: 'Area',
      serviceCategories: 'Area Pengetahuan',
      byUsage: 'berdasarkan Penggunaan',
      category: 'Area'
    },
    tooltips: {
      selectPeriod: 'Pilih periode waktu',
      selectDate: 'Pilih tanggal',
      exportData: 'Ekspor data'
    },
    gauge: {
      historical: 'Tren Historis',
      vsPrevious: 'vs periode sebelumnya',
      target: 'Target'
    },
    ratings: {
      poor: "Buruk",
      average: "Rata-rata",
      good: "Baik",
      excellent: "Sangat Baik"
    },
    slower: 'lebih lambat',
    faster: 'lebih cepat',
    percentage: 'Persentase',
    note: 'Di bawah ini adalah statistik penggunaan dan ringkasan umpan balik pengguna.',
    usageStats: 'Statistik Penggunaan',
    peakUsers: 'Pengguna Puncak Bersamaan',
    activeChats: 'Obrolan Aktif',
    usageTrend: 'Tren Penggunaan',
    topQueries: 'Pertanyaan Teratas',
    feedbackSamples: 'Contoh Umpan Balik Pengguna',
    close: 'Tutup',
    chartComingSoon: 'Visualisasi grafik interaktif akan segera hadir...',
    retry: 'Coba Lagi',
    dailyQueries: 'Pertanyaan Harian',
    export: 'Ekspor Data',
    dateRange: 'Rentang Tanggal',
    startDate: 'Tanggal Mulai',
    endDate: 'Tanggal Selesai',
    rank: 'Peringkat',
    query: 'Pertanyaan',
    count: 'Jumlah',
    avgTime: 'Waktu Rata-rata',
    serviceUsage: 'Penggunaan Area Pengetahuan',
    usageTrends: 'Tren Penggunaan',
    week: 'Minggu Lalu',
    month: 'Bulan Lalu',
    quarter: 'Kuartal Lalu',
    year: 'Tahun Lalu',
    uniqueUsers: 'Pengguna Unik',
    satisfactionRate: 'Tingkat Kepuasan',
    satisfactionAnalysis: 'Analisis Kepuasan Pengguna'
  },
  brandName: 'Genie AI: Asisten Digital Pemerintah Anda',
  nav: {
    systemStatus: 'Status Sistem',
    menu: 'Menu',
    analytics: 'Analitik',
    userProfile: 'Profil Pengguna',
    settings: 'Pengaturan',
    logout: 'Keluar',
    profile: 'Profil Saya',
    toggleSidebar: 'Beralih sidebar',
    changeLanguage: 'Ubah bahasa',
    administration: "Administrasi",
    languages: {
      english: 'Inggris',
      french: 'Prancis',
      swahili: 'Swahili'
    }
  },
  systemStatus: {
    title: 'Status Layanan',
    services: 'Layanan',
    operational: 'Beroperasi',
    degraded: 'Terganggu',
    outage: 'Padam',
    allOperational: 'Semua Sistem Beroperasi',
    someIssues: 'Beberapa Masalah',
    majorIssues: 'Masalah Besar',
    checking: 'Memeriksa...',
    nextDeadline: 'Tenggat Berikutnya',
    days: 'hari',
    viewDetails: 'Lihat Detail'
  },
  services: {
    eCitizen: 'Portal eCitizen',
    taxFiling: 'Sistem Pelaporan Pajak',
    idApplication: 'Aplikasi KTP',
    businessReg: 'Pendaftaran Usaha',
    drivingLicense: 'Surat Izin Mengemudi'
  },
  deadlines: {
    taxFiling: 'Tenggat Pelaporan Pajak',
    businessRenewal: 'Perpanjangan Izin Usaha',
    idRenewal: 'Perpanjangan KTP',
    vehicleRegistration: 'Tenggat Registrasi Kendaraan'
  },
  sidebar: {
    governmentServices: 'Area Pengetahuan',
    chatHistory: 'Riwayat Obrolan',
    searchPlaceholder: 'Cari area pengetahuan...',
    createFolder: 'Buat Folder',
    editFolder: 'Ubah Folder',
    folderName: 'Nama Folder',
    folderNamePlaceholder: 'Masukkan nama folder',
    moveChat: 'Pindahkan Obrolan',
    moveChatTo: 'Pindahkan Obrolan Ke',
    selectFolder: 'Pilih Folder',
    deleteChat: 'Hapus Obrolan',
    deleteChatConfirm: 'Apakah Anda yakin ingin menghapus obrolan ini?',
    deleteChatWarning: 'Tindakan ini tidak dapat dibatalkan.',
    renameChat: "Ubah Nama Obrolan",
    chatTitle: "Judul Obrolan",
    chatTitlePlaceholder: "Masukkan judul untuk obrolan ini",
    deleteFolder: "Hapus Folder",
    deleteFolderConfirm: "Apakah Anda yakin ingin menghapus folder '{name}'?",
    chatsMoveWarning: "Semua obrolan di folder ini akan dipindahkan ke folder default.",
    weatherTitle: "Prakiraan Cuaca",
    weatherLoading: "Memuat data cuaca...",
    weatherError: "Tidak dapat memuat data cuaca. Silakan coba lagi.",
    weatherLocationLoading: 'Memuat lokasi...',
    weatherErrorDefault: 'Tidak dapat mengambil data cuaca.',
    weatherGeolocationUnsupported: 'Geolokasi tidak didukung oleh browser Anda.',
    weatherRefresh: 'Segarkan Cuaca',
    weatherConditions: {
      clear: 'Cerah',
      partlycloudy: 'Berawan Sebagian',
      cloudy: 'Berawan',
      overcast: 'Mendung',
      rain: 'Hujan',
      shower: 'Hujan Ringan',
      thunderstorm: 'Badai Petir',
      snow: 'Salju'
    },
    title: 'Info & Sumber Daya',
    noChats: 'Tidak ada obrolan terbaru',
    relatedDocs: 'Dokumen Terkait',
    noDocuments: 'Tidak ada dokumen terkait',
    faq: 'Pertanyaan yang Sering Diajukan',
    tab: {
      all: 'Semua Obrolan',
      folders: 'Folder',
      starred: 'Berbintang',
      archived: 'Diarsipkan'
    },
    savedChats: 'Obrolan Tersimpan',
    chats: 'Obrolan',
    allChats: "Semua Obrolan",
    folders: "Folder",
    starredChats: "Berbintang",
    archivedChats: "Diarsipkan",
    noFolder: "Tanpa Folder",
    emptyFolder: "Folder ini kosong. Pindahkan percakapan ke sini dari menu obrolan.",
    noStarredChats: "Belum ada percakapan berbintang. Bintangi percakapan untuk menambahkannya di sini.",
    noArchivedChats: "Belum ada percakapan yang diarsipkan.",
    noSearchResults: 'Tidak ada percakapan yang ditemukan untuk "{term}"',
    loadingChats: "Memuat obrolan...",
    errorLoadingConversations: "Gagal memuat percakapan. Silakan coba lagi.",
    errorLoadingUser: "Data pengguna tidak lengkap. Silakan muat ulang halaman.",
    errorNoUser: "Data pengguna hilang. Silakan muat ulang halaman.",
    retry: "Coba Lagi",
    message: "pesan",
    messages: "pesan",
    created: "Dibuat",
    updated: "Diperbarui",
    star: "Bintangi",
    unstar: "Hapus Bintang",
    archive: "Arsipkan",
    chatStarred: "Percakapan telah dibintangi",
    chatUnstarred: "Bintang percakapan telah dihapus",
    chatArchived: "Percakapan telah diarsipkan",
    chatUnarchived: "Percakapan telah dikeluarkan dari arsip",
    errorUpdatingChat: "Gagal memperbarui percakapan",
    chatRenamed: "Percakapan berhasil diubah namanya",
    errorRenamingChat: "Gagal mengubah nama percakapan",
    chatDeleted: "Percakapan berhasil dihapus",
    errorDeletingChat: "Gagal menghapus percakapan",
    chatMoved: "Percakapan berhasil dipindahkan",
    errorMovingChat: "Gagal memindahkan percakapan",
    noPreview: "Tidak ada pratinjau yang tersedia",
    searchConversations: 'Cari percakapan...',
    selectFolderInstruction: "Pilih folder untuk melihat percakapannya",
    folderCreated: "Folder berhasil dibuat",
    errorCreatingFolder: "Gagal membuat folder",
    errorLoadingFolders: "Gagal memuat folder",
    folderUpdated: "Folder berhasil diperbarui",
    errorUpdatingFolder: "Gagal memperbarui folder",
    folderDeleted: "Folder berhasil dihapus",
    errorDeletingFolder: "Gagal menghapus folder",
    chatRemovedFromFolders: "Percakapan dihapus dari folder",
    errorRemovingChat: "Gagal menghapus percakapan dari folder",
    id: "ID",
    labels: "Label",
    confidence: "Keyakinan",
    unknown: "Tidak diketahui"
  },
  leftPanel: {
    cat1: {
      name: '1. Identitas & Registrasi Sipil',
      children: ['Akta kelahiran', 'KTP', 'Paspor', 'Akta nikah dan kematian', 'Registrasi pemilih']
    },
    cat2: {
      name: '2. Layanan Kesehatan & Sosial',
      children: ['Akses layanan kesehatan publik', 'Program vaksinasi', 'Asuransi kesehatan', 'Tunjangan disabilitas', 'Bantuan sosial dan pangan']
    },
    cat3: {
      name: '3. Pendidikan & Pembelajaran',
      children: ['Sekolah dan universitas negeri', 'Beasiswa dan pinjaman mahasiswa', 'Program pendidikan orang dewasa', 'Sumber belajar online']
    },
    cat4: {
      name: '4. Ketenagakerjaan & Layanan Buruh',
      children: ['Pencarian kerja dan tunjangan pengangguran', 'Perlindungan dan hak pekerja', 'Peraturan keselamatan kerja', 'Pelatihan keterampilan dan magang']
    },
    cat5: {
      name: '5. Pajak & Pendapatan',
      children: ['Pelaporan pajak penghasilan dan restitusi', 'Pembayaran pajak properti', 'Kepatuhan pajak bisnis', 'Bea cukai dan impor']
    },
    cat6: {
      name: '6. Keamanan & Keadilan Publik',
      children: ['Polisi dan layanan darurat', 'Pengadilan dan layanan bantuan hukum', 'Pelaporan kejahatan', 'Hukum perlindungan konsumen']
    },
    cat7: {
      name: '7. Transportasi & Mobilitas',
      children: ['SIM dan registrasi kendaraan', 'Transportasi umum dan infrastruktur', 'Pelanggaran lalu lintas dan denda', 'Program keselamatan jalan']
    },
    cat8: {
      name: '8. Perumahan & Pembangunan Kota',
      children: ['Bantuan perumahan rakyat', 'Pendaftaran properti dan catatan tanah', 'Pinjaman dan subsidi perumahan', 'Izin zonasi dan bangunan']
    },
    cat9: {
      name: '9. Utilitas & Lingkungan',
      children: ['Layanan air dan listrik', 'Pengelolaan limbah dan daur ulang', 'Peraturan lingkungan', 'Inisiatif energi terbarukan']
    },
    cat10: {
      name: '10. Bisnis & Perdagangan',
      children: ['Pendaftaran dan perizinan usaha', 'Peraturan dan izin perdagangan', 'Hibah dan insentif UKM', 'Dukungan e-commerce dan bisnis digital']
    },
    cat11: {
      name: '11. Jaminan Sosial & Pensiun',
      children: ['Manfaat pensiun', 'Manajemen dana pensiun', 'Manfaat ahli waris', 'Pensiun cacat']
    },
    cat12: {
      name: '12. Keterlibatan Masyarakat & Sipil',
      children: ['Pemungutan suara dan pemilu', 'Umpan balik publik dan keluhan warga', 'Program sukarela dan komunitas', 'Partisipasi pemerintah daerah']
    }
  },
  settings: {
    title: 'Pengaturan',
    save: 'Simpan',
    close: 'Tutup',
    saveSettings: 'Simpan Pengaturan',
    savingSettings: "Menyimpan pengaturan Anda...",
    settingsSaved: "Pengaturan berhasil disimpan!",
    saveSuccess: 'Pengaturan berhasil disimpan',
    saveError: 'Kesalahan menyimpan pengaturan',
    display: 'Tampilan',
    displayLanguage: 'Bahasa Tampilan',
    languages: {
      english: 'Inggris',
      french: 'Prancis',
      swahili: 'Swahili'
    },
    theme: 'Tema',
    themes: {
      light: 'Terang',
      dark: 'Gelap',
      system: 'Sistem'
    },
    fontSize: 'Ukuran Font',
    notifications: 'Notifikasi',
    emailUpdates: 'Pembaruan email',
    soundNotifications: 'Notifikasi suara',
    accountManagement: 'Manajemen Akun',
    emailAddress: 'Alamat Email',
    emailAddressPlaceholder: 'Alamat email Anda',
    password: 'Kata Sandi',
    changePassword: 'Ubah Kata Sandi',
    resetUserData: 'Atur Ulang Data Pengguna',
    resetUserDataDesc: 'Ini akan menghapus semua data profil dan riwayat obrolan Anda.',
    deleteAccount: 'Hapus Akun',
    deleteAccountDesc: 'Ini akan menghapus akun Anda dan semua data terkait secara permanen.',
    edit: 'Ubah',
    standardAccount: 'Akun Standar',
    confirmEmailChange: 'Konfirmasi Perubahan Email',
    pleaseEnterPassword: 'Harap masukkan kata sandi Anda',
    cancel: 'Batal',
    account: {
      title: 'Akun',
      resetDescription: 'Ini akan menghapus semua data profil dan riwayat obrolan Anda.',
      confirmReset: 'Apakah Anda yakin ingin mengatur ulang semua data Anda? Tindakan ini tidak dapat dibatalkan.',
      resetComplete: 'Data Anda telah diatur ulang.'
    },
    language: {
      title: 'Bahasa',
      selectLabel: 'Bahasa Tampilan'
    },
    appearance: {
      title: 'Tampilan',
      lightTheme: 'Terang',
      darkTheme: 'Gelap',
      systemTheme: 'Sistem'
    },
    confirmDeleteAccount: 'Apakah Anda yakin ingin menghapus akun Anda? Tindakan ini tidak dapat dibatalkan.',
    confirmAccountDeletion: 'Konfirmasi Penghapusan Akun',
    accountDeletionWarning: 'Peringatan: Tindakan ini bersifat permanen dan tidak dapat dibatalkan. Semua data Anda akan dihapus secara permanen.',
    deletionReason: 'Alasan penghapusan (opsional):',
    deletionReasonPlaceholder: 'Apa yang membuat Anda memutuskan untuk menghapus akun Anda?',
    enterPasswordConfirm: 'Masukkan kata sandi Anda untuk mengonfirmasi:',
    currentPasswordPlaceholder: 'Kata sandi Anda saat ini',
    deleting: 'Menghapus...',
    permanentlyDeleteAccount: 'Hapus Akun',
    accountDeletedSuccess: 'Akun Anda telah berhasil dihapus.',
    incorrectPassword: 'Kata sandi salah',
    accountDeletionFailed: 'Gagal menghapus akun. Silakan coba lagi nanti.',
    confirmChange: 'Konfirmasi Perubahan',
    processing: 'Memproses...',
    userDataReset: 'Data profil Anda berhasil diatur ulang.',
    failedToResetUserData: 'Gagal mengatur ulang data profil Anda. Silakan coba lagi nanti.',
    changingEmailTo: 'Mengubah email Anda menjadi',
    will: 'akan',
    logOutSystem: 'Mengeluarkan Anda dari sistem',
    sendVerificationLink: 'Mengirim tautan verifikasi ke email baru Anda',
    requireVerification: 'Memerlukan verifikasi sebelum Anda dapat masuk lagi',
    checkNewEmailVerification: 'Silakan periksa email baru Anda untuk instruksi verifikasi.',
    unableToVerifyEmail: 'Tidak dapat memverifikasi email. Silakan coba lagi.',
    emailAlreadyInUse: 'Email sudah digunakan',
    enterValidEmail: 'Harap masukkan alamat email yang valid',
    failedToUpdateEmail: 'Gagal memperbarui email. Silakan coba lagi.',
    passwordResetInitiated: 'Tautan atur ulang kata sandi telah dikirim ke alamat email Anda.',
    unableToLoadUser: 'Tidak dapat memuat informasi pengguna. Silakan coba lagi.',
    retry: 'Coba Lagi',
    user: 'Pengguna',
    loadingUserInfo: 'Memuat informasi pengguna...',
    resetUserDataTitle: "Atur Ulang Data Pengguna",
    confirmResetUserData: "Apakah Anda yakin ingin mengatur ulang semua data profil Anda? Ini akan menghapus semua informasi profil dan riwayat obrolan Anda, tetapi kredensial akun Anda akan tetap ada.",
    reset: "Atur Ulang",
    deleteAccountTitle: "Hapus Akun"
  },
  userProfile: {
    title: 'Profil Pengguna',
    privacyInfo: "Dengan memberikan informasi lebih lanjut, Anda akan mendapatkan respons yang lebih akurat dan bermakna dari chatbot. Tinjau",
    privacyPolicyLink: 'Kebijakan Privasi',
    tabComingSoon: 'Tab ini sedang dalam pengembangan dan akan segera tersedia.',
    saveSuccess: 'Profil berhasil disimpan',
    loadError: 'Kesalahan memuat data profil',
    saveError: 'Kesalahan menyimpan profil',
    confirmSaveTitle: "Simpan Profil",
    confirmSave: "Apakah Anda yakin ingin menyimpan perubahan ini?",
    confirmCancel: 'Anda memiliki perubahan yang belum disimpan. Apakah Anda yakin ingin membatalkan?',
    confirmLeave: 'Apakah Anda yakin ingin pergi? Perubahan yang belum disimpan akan hilang.',
    confirmDiscardChanges: 'Buang perubahan yang belum disimpan?',
    uploadPhoto: 'Unggah Foto',
    uploadFile: 'Unggah File',
    photoRequirements: 'Foto harus jelas, terbaru, dan menunjukkan seluruh wajah Anda',
    biometricRequirements: 'Hanya file data biometrik resmi yang diterima',
    documentUpload: 'Unggah Dokumen',
    validationTitle: 'Harap perbaiki kesalahan berikut:',
    profileIcon: 'Ikon Profil',
    change: 'Ubah',
    chooseProfileIcon: 'Pilih Ikon Profil',
    presetIcons: 'Ikon Preset',
    upload: 'Unggah',
    initials: 'Inisial',
    clickToUpload: 'Klik untuk mengunggah',
    useThisImage: 'Gunakan Gambar Ini',
    useInitials: 'Gunakan Inisial',
    tabs: {
      tab1: 'Data Identifikasi Pribadi',
      tab2: 'Pencatatan Sipil & Dokumentasi',
      tab3: 'Informasi Alamat & Tempat Tinggal',
      tab4: 'Dokumen Identitas & Perjalanan',
      tab5: 'Catatan Kesehatan & Medis',
      tab6: 'Data Pekerjaan & Ekonomi',
      tab7: 'Catatan Pendidikan & Akademik',
      tab8: 'Data Keuangan & Pajak',
      tab9: 'Jaminan Sosial & Kesejahteraan',
      tab10: 'Catatan Kriminal & Hukum',
      tab11: 'Transportasi & Mobilitas',
      tab12: 'Partisipasi Sipil & Politik'
    },
    actions: {
      cancel: 'Batal',
      save: 'Simpan Profil',
      previous: 'Sebelumnya',
      next: 'Berikutnya',
      saving: 'Menyimpan...'
    },
    fields: {
      fullName: 'Nama lengkap (termasuk alias)',
      dob: 'Tanggal lahir',
      gender: 'Jenis Kelamin',
      nationality: 'Kewarganegaraan',
      maritalStatus: 'Status perkawinan',
      photograph: 'Foto',
      biometric: 'Sidik jari / Data biometrik',
      birthCert: 'Akta kelahiran',
      deathCert: 'Akta kematian',
      marriageDivorce: 'Catatan nikah / cerai',
      adoption: 'Catatan adopsi',
      citizenship: 'Dokumen kewarganegaraan / naturalisasi',
      immigration: 'Riwayat imigrasi & visa',
      currentAddress: 'Alamat tempat tinggal saat ini',
      previousAddresses: 'Alamat sebelumnya',
      postalCode: 'Kode Pos',
      country: 'Negara',
      residencyStatus: 'Status Tinggal',
      homeOrRental: 'Detail kepemilikan rumah atau sewa',
      utilityBills: 'Tagihan utilitas yang terhubung dengan alamat',
      landRecords: 'Catatan kepemilikan tanah dan properti',
      idCard: 'Nomor KTP',
      passport: 'Detail paspor',
      driversLicense: "Surat Izin Mengemudi",
      voterId: 'ID Pemilih',
      ssn: 'Nomor Jaminan Sosial / Asuransi Nasional',
      militaryRecords: 'Catatan dinas militer',
      medicalHistory: 'Riwayat medis dan kondisi kesehatan',
      vaccinations: 'Catatan vaksinasi',
      insuranceDetails: 'Detail asuransi kesehatan',
      disability: 'Status disabilitas',
      bloodType: 'Golongan Darah',
      organDonor: 'Status donor organ',
      prescriptions: 'Resep dan perawatan yang diterima',
      mentalHealth: 'Riwayat kesehatan mental',
      eHistory: 'Riwayat pekerjaan',
      currentEmployer: 'Detail perusahaan saat ini',
      workPermits: 'Izin kerja dan kontrak kerja',
      certifications: 'Sertifikasi dan lisensi profesional',
      unemployment: 'Status pengangguran dan tunjangan yang diterima',
      tin: 'Nomor Pokok Wajib Pajak (NPWP)',
      businessAffiliations: 'Kepemilikan bisnis dan afiliasi perusahaan',
      schools: 'Sekolah dan universitas yang pernah diikuti',
      education: 'Pendidikan',
      degrees: 'Diploma, gelar, dan sertifikasi',
      performance: 'Kinerja akademik dan nilai tes',
      academicRecords: "Catatan Akademik",
      scholarships: 'Beasiswa dan bantuan keuangan yang diterima',
      incomeTax: 'Catatan pajak penghasilan',
      bankAccounts: 'Rekening bank dan keuangan',
      propertyTax: 'Pembayaran pajak properti',
      businessTax: 'Pelaporan pajak bisnis',
      pensionContrib: 'Kontribusi dan penarikan pensiun',
      loanAid: 'Catatan pinjaman dan bantuan pemerintah',
      pensionStatus: 'Status dan kontribusi pensiun',
      childcare: 'Bantuan penitipan anak',
      foodAssistance: 'Program bantuan pangan / kesejahteraan',
      housingAssistance: 'Bantuan perumahan',
      policeRecords: 'Catatan kepolisian (riwayat kriminal, penangkapan, tuduhan)',
      courtCases: 'Riwayat kasus pengadilan',
      finesPenalties: 'Denda dan penalti',
      paroleProbation: 'Status pembebasan bersyarat atau masa percobaan',
      citizenshipRevocation: 'Pencabutan kewarganegaraan (jika berlaku)',
      vehicleReg: 'Detail registrasi kendaraan',
      trafficViolations: 'Pelanggaran lalu lintas dan denda',
      licenseHistory: 'Riwayat dan pengesahan surat izin mengemudi',
      publicTransportCard: 'Penggunaan kartu transportasi umum',
      voterRegistration: 'Detail registrasi pemilih',
      electionHistory: 'Riwayat partisipasi pemilu',
      partyMembership: 'Keanggotaan partai politik',
      militaryStatus: 'Dinas militer atau status wajib militer',
      publicServiceRoles: 'Peran layanan publik'
    },
    placeholders: {
      fullName: 'Masukkan nama lengkap resmi Anda',
      nationality: 'Masukkan kewarganegaraan Anda',
      searchCountries: 'Cari negara...',
      selectCountry: 'Pilih negara',
      searchDisciplines: "Cari disiplin ilmu...",
      selectDiscipline: "Pilih disiplin ilmu",
      searchDegrees: "Cari gelar...",
      selectDegree: "Pilih gelar"
    },
    validation: {
      nameRequired: 'Nama lengkap wajib diisi',
      dobRequired: 'Tanggal lahir wajib diisi',
      dobFuture: 'Tanggal lahir tidak boleh di masa depan',
      requiredField: '{field} wajib diisi',
      invalidFormat: 'Format tidak valid untuk {field}',
      futureDate: 'Tanggal tidak boleh di masa depan',
      invalidSelection: 'Harap buat pilihan yang valid',
      passwordLength: 'Kata sandi harus minimal 8 karakter',
      matchError: 'Bidang tidak cocok'
    },
    errors: {
      savingFailed: 'Gagal menyimpan profil',
      loadingFailed: 'Gagal memuat data profil',
      invalidForm: 'Harap isi semua bidang yang wajib diisi',
      invalidFileType: 'Jenis file tidak valid',
      fileTooLarge: 'File terlalu besar',
      countryLoadError: 'Kesalahan memuat negara',
      countryUpdateError: 'Kesalahan memperbarui negara'
    },
    notifications: {
      saveSuccess: 'Profil berhasil disimpan',
      saveFailed: 'Gagal menyimpan profil',
      loadSuccess: 'Profil berhasil dimuat',
      loadFailed: 'Gagal memuat profil',
      fieldRequired: 'Bidang ini wajib diisi',
      uploadSuccess: 'File berhasil diunggah',
      uploadFailed: 'Gagal mengunggah file',
      formChanged: 'Anda memiliki perubahan yang belum disimpan',
      sessionExpired: 'Sesi Anda telah berakhir, silakan masuk lagi',
      profileUpdated: 'Profil Anda telah diperbarui',
      profileIncomplete: 'Profil Anda tidak lengkap'
    },
    instructions: {
      fullNameHelp: 'Masukkan nama lengkap resmi Anda seperti yang tertera di dokumen resmi Anda',
      dobHelp: 'Masukkan tanggal lahir Anda dalam format BB/HH/TTTT',
      uploadPhotoHelp: 'Unggah foto terbaru. File harus berupa JPG, PNG, atau GIF dan kurang dari 2MB',
      passwordHelp: 'Kata sandi harus minimal 8 karakter dengan satu huruf besar, satu angka, dan satu karakter khusus',
      documentHelp: 'Format yang diterima: PDF, JPG, PNG (maks 5MB)',
      requiredFields: 'Bidang yang ditandai dengan * wajib diisi',
      selectFromList: 'Silakan pilih opsi dari daftar',
      nextTab: 'Lanjutkan ke bagian berikutnya',
      previousTab: 'Kembali ke bagian sebelumnya',
      saveInstructions: 'Klik Simpan untuk menyimpan informasi Anda',
      cancelInstructions: 'Klik Batal untuk membuang perubahan'
    },
    completionStatus: {
      notStarted: 'Belum Dimulai',
      inProgress: 'Sedang Berlangsung',
      complete: 'Selesai',
      percentComplete: '{percent}% Selesai',
      tabsCompleted: '{completed} dari {total} bagian selesai',
      tabComplete: 'Tab selesai!'
    },
    gender: {
      male: 'Pria',
      female: 'Wanita',
      other: 'Lainnya',
      preferNot: 'Tidak ingin menyebutkan'
    },
    maritalStatus: {
      single: 'Lajang',
      married: 'Menikah',
      divorced: 'Bercerai',
      widowed: 'Duda/Janda',
      other: 'Lainnya'
    },
    residencyStatuses: {
      citizen: 'Warga Negara',
      permanentResident: 'Penduduk Tetap',
      temporaryResident: 'Penduduk Sementara',
      other: 'Lainnya'
    },
    employmentStatuses: {
      employed: 'Bekerja',
      selfEmployed: 'Wiraswasta',
      unemployed: 'Tidak Bekerja',
      student: 'Pelajar/Mahasiswa',
      retired: 'Pensiun',
      homemaker: 'Ibu Rumah Tangga',
      other: 'Lainnya'
    },
    educationLevels: {
      primary: 'Pendidikan Dasar',
      secondary: 'Pendidikan Menengah',
      highSchool: 'Sekolah Menengah Atas',
      vocational: 'Pelatihan Kejuruan',
      associate: 'Diploma',
      bachelor: 'Sarjana (S1)',
      master: 'Magister (S2)',
      doctoral: 'Doktor (S3)',
      professional: 'Gelar Profesional',
      other: 'Lainnya'
    },
    proficiencyLevels: {
      native: 'Asli',
      fluent: 'Lancar',
      advanced: 'Mahir',
      intermediate: 'Menengah',
      basic: 'Dasar'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Tidak Diketahui'
    },
    languages: {
      english: 'Inggris',
      french: 'Prancis',
      swahili: 'Swahili',
      arabic: 'Arab',
      spanish: 'Spanyol',
      portuguese: 'Portugis',
      chinese: 'Mandarin',
      japanese: 'Jepang',
      german: 'Jerman',
      russian: 'Rusia',
      hindi: 'Hindi',
      urdu: 'Urdu',
      other: 'Lainnya'
    },
    yesNo: {
      yes: 'Ya',
      no: 'Tidak'
    },
    select: 'Silakan pilih',
    existingFile: 'File yang ada',
    noMatchingCountries: 'Tidak ada negara yang cocok',
    noMatchingDisciplines: "Tidak ada disiplin ilmu yang cocok",
    noMatchingDegrees: "Tidak ada gelar yang cocok",
    educationOptions: [
      "Akuntansi", "Teknik Dirgantara", "Ilmu Pertanian", "Antropologi", "Arsitektur", "Sejarah Seni",
      "Kecerdasan Buatan", "Astronomi", "Astrofisika", "Biokimia", "Teknik Biomedis", "Bioteknologi",
      "Administrasi Bisnis", "Teknik Kimia", "Kimia", "Teknik Sipil", "Komunikasi", "Teknik Komputer",
      "Ilmu Komputer", "Manajemen Konstruksi", "Peradilan Pidana", "Keamanan Siber", "Ilmu Data",
      "Kedokteran Gigi", "Ekonomi", "Pendidikan", "Teknik Elektro", "Pendidikan Dasar", "Sastra Inggris",
      "Teknik Lingkungan", "Ilmu Lingkungan", "Desain Mode", "Studi Film", "Keuangan", "Seni Rupa",
      "Ilmu Pangan", "Ilmu Forensik", "Desain Game", "Geografi", "Geologi", "Desain Grafis",
      "Administrasi Kesehatan", "Sejarah", "Manajemen Perhotelan", "Sumber Daya Manusia", "Desain Industri",
      "Teknik Industri", "Sistem Informasi", "Teknologi Informasi", "Desain Interior", "Bisnis Internasional",
      "Hubungan Internasional", "Jurnalisme", "Hukum", "Ilmu Perpustakaan", "Linguistik", "Manajemen",
      "Pemasaran", "Ilmu Material", "Matematika", "Teknik Mesin", "Studi Media", "Kedokteran",
      "Meteorologi", "Mikrobiologi", "Musik", "Nanoteknologi", "Keperawatan", "Gizi", "Terapi Okupasi",
      "Oseanografi", "Teknik Perminyakan", "Farmasi", "Filsafat", "Fotografi", "Pendidikan Jasmani",
      "Fisioterapi", "Fisika", "Ilmu Politik", "Psikologi", "Administrasi Publik", "Kesehatan Masyarakat",
      "Hubungan Masyarakat", "Robotika", "Pendidikan Menengah", "Pekerjaan Sosial", "Sosiologi",
      "Rekayasa Perangkat Lunak", "Pendidikan Khusus", "Manajemen Olahraga", "Statistik", "Teknik Sistem",
      "Seni Teater", "Pariwisata", "Perencanaan Kota", "Kedokteran Hewan", "Pengembangan Web",
      "Biologi Satwa Liar", "Zoologi"
    ],
    degreeOptions: [
      "Diploma", "Sarjana Seni (B.A.)", "Sarjana Sains (B.S.)", "Sarjana Teknik (B.Eng.)",
      "Sarjana Administrasi Bisnis (B.B.A.)", "Sarjana Seni Rupa (B.F.A.)", "Sarjana Pendidikan (B.Ed.)",
      "Sarjana Kedokteran (MBBS)", "Sarjana Hukum (LL.B.)", "Magister Seni (M.A.)", "Magister Sains (M.S.)",
      "Magister Administrasi Bisnis (M.B.A.)", "Magister Teknik (M.Eng.)", "Magister Seni Rupa (M.F.A.)",
      "Magister Pendidikan (M.Ed.)", "Magister Hukum (LL.M.)", "Magister Kesehatan Masyarakat (M.P.H.)",
      "Doktor Filsafat (Ph.D.)", "Doktor Kedokteran (M.D.)", "Doktor Pendidikan (Ed.D.)",
      "Doktor Administrasi Bisnis (D.B.A.)", "Doktor Yurisprudensi (J.D.)", "Diploma Profesional",
      "Diploma Teknis", "Sertifikat Kejuruan", "Sertifikat Pascasarjana", "Diploma Pascasarjana", "Pascadoktoral"
    ],
    aria: {
      tabList: 'Bagian formulir profil',
      nextButton: 'Lanjut ke bagian berikutnya',
      prevButton: 'Kembali ke bagian sebelumnya',
      closeButton: 'Tutup formulir profil',
      saveButton: 'Simpan data profil',
      requiredField: 'Bidang wajib diisi',
      dropdownSelect: 'Pilih opsi'
    }
  },
  chatbot: {
    placeholder: 'Ketik pertanyaan Anda di sini...',
    sendButton: 'Kirim',
    fileReceived: 'File berhasil diterima.',
    fileUploadError: 'Kesalahan mengunggah file.',
    processingError: 'Kesalahan memproses permintaan Anda.',
    welcomeMessage: 'Selamat datang! Bagaimana saya bisa membantu Anda dengan layanan pemerintah Kenya hari ini?',
    attachFile: 'Lampirkan File',
    fileTooLarge: 'File terlalu besar. Ukuran maksimum adalah {maxSize}.',
    saveChat: 'Simpan Obrolan',
    chatSaved: 'Obrolan Disimpan',
    chatTitle: 'Judul Obrolan',
    chatTitlePlaceholder: 'Masukkan judul untuk obrolan ini',
    selectFolder: 'Pilih Folder',
    newChat: 'Obrolan Baru',
    clearContext: 'Hapus konteks dan mulai percakapan baru',
    unsavedChanges: 'Anda memiliki perubahan yang belum disimpan. Apakah Anda yakin ingin memulai obrolan baru?',
    whatCanIHelp: "Ada yang bisa saya bantu hari ini?",
    justChat: "Hanya Mengobrol",
    queryContext: "Konteks Pertanyaan",
    contextAdded: 'Konteks ditambahkan ke pertanyaan Anda',
    contextRemoved: 'Konteks dihapus dari pertanyaan Anda',
    sessionUpdated: 'Sesi diperbarui',
    newChatStarted: 'Memulai percakapan baru',
    loadError: 'Tidak dapat memuat riwayat obrolan',
    responsePrefix: "Saya menerima pesan Anda",
    withContext: "dengan konteks",
    conversationLoaded: "Percakapan berhasil dimuat!",
    saveConfirmTitle: "Simpan Percakapan yang Ada",
    saveConfirmMessage: "Simpan percakapan yang ada?",
    loadConfirmTitle: "Muat Percakapan yang Ada",
    loadConfirmMessage: "Anda memiliki perubahan yang belum disimpan. Apakah Anda ingin membuangnya dan memuat percakapan yang dipilih, atau simpan percakapan saat ini terlebih dahulu?",
    loadAndDiscard: "Muat dan Buang",
    saveAndLoad: "Simpan dan Muat",
    saveAndStartNew: "Simpan dan Mulai Baru",
    discardAndStartNew: "Buang dan Mulai Baru",
    newChatTitle: "Mulai Obrolan Baru",
    exportChat: 'Ekspor Obrolan',
    exportFilename: 'Nama File',
    exportFilenamePlaceholder: 'Masukkan nama file',
    exportButton: 'Ekspor',
    exportSuccess: 'Obrolan berhasil diekspor',
    exportError: 'Gagal mengekspor obrolan. Silakan coba lagi.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "Ajukan KTP",
    payTaxes: "Bayar Pajak",
    startBusiness: "Mulai Usaha",
    findHealthcare: "Kesehatan",
    educationServices: "Pendidikan",
    transportLicenses: "Transportasi",
    housingPrograms: "Perumahan",
    findJobs: "Pekerjaan",
    justChat: "Ngobrol",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "Saya ingin mengobrol tentang layanan pemerintah",
    applyForIDUserPrompt: "Saya butuh informasi cara mengajukan KTP",
    payTaxesUserPrompt: "Bagaimana proses membayar pajak saya secara online?",
    startBusinessUserPrompt: "Bimbing saya melalui langkah-langkah untuk mendaftarkan bisnis baru",
    findHealthcareUserPrompt: "Di mana saya bisa mencari informasi tentang layanan kesehatan masyarakat?",
    educationServicesUserPrompt: "Layanan pendidikan apa yang tersedia untuk anak-anak saya?",
    transportLicensesUserPrompt: "Bagaimana cara memperpanjang SIM saya?",
    housingProgramsUserPrompt: "Beri tahu saya tentang program perumahan terjangkau di Kenya",
    findJobsUserPrompt: "Peluang kerja pemerintah apa yang saat ini tersedia?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'Batal',
    create: 'Buat',
    save: 'Simpan',
    move: 'Pindahkan',
    delete: 'Hapus',
    // --- NEW KEYS ADDED ---
    ok: 'OK',
    ingest: 'Proses',
    retract: 'Tarik Kembali',
    loading: 'Memuat...',
    refresh: 'Segarkan'
  },
  feedback: {
    title: 'Umpan Balik',
    button: 'Umpan Balik',
    positive: 'Umpan balik positif',
    negative: 'Umpan balik negatif',
    promptText: 'Apakah respons ini membantu?',
    placeholder: 'Komentar tambahan...',
    submit: 'Kirim Umpan Balik',
    close: 'Batal',
    thankYouMessage: 'Terima kasih atas umpan balik Anda!',
    submitting: 'Mengirim...',
    error: 'Terjadi kesalahan. Silakan coba lagi.',
    success: 'Terima kasih atas umpan balik Anda!',
  },
  responseRating: {
    title: 'Bantu Kami Berkembang',
    note: 'Umpan balik Anda akan digunakan untuk menyempurnakan chatbot dan meningkatkan respons dari waktu ke waktu.',
    chatbotResponse: 'Respons Chatbot:',
    ratingLabels: {
      1: 'Tidak Berguna',
      2: 'Sedikit Membantu',
      3: 'Cukup Membantu',
      4: 'Sangat Membantu',
      5: 'Mengubah Hidup'
    },
    additionalComments: 'Komentar tambahan...',
    submit: 'Kirim',
    cancel: 'Batal'
  },
  // --- NEW OBJECTS ---
  upload: {
    alt: 'Unggah'
  },
  details: {
    loading: 'Memuat Detail File...',
    title: 'Detail File',
    close: 'Tutup',
    fileName: 'Nama File',
    author: 'Penulis',
    labels: 'Label',
    selectAll: 'Pilih Semua',
    loadingLabels: 'Memuat label...',
    status: 'Status',
    fileId: 'ID File',
    fileType: 'Tipe File',
    viewFile: 'Lihat File',
    visitLink: 'Kunjungi Tautan Eksternal',
    openFile: 'Buka file di tab baru',
    fileSize: 'Ukuran File',
    uploadDate: 'Tanggal Unggah',
    hash: 'Hash SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "Detail",
      ingestionLog: "Log Pemrosesan"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Tindakan Penghentian:",
      killDocument: "Hentikan Dokumen Ini",
      killProcess: "Hentikan Proses Pemrosesan",
      timestamp: "Cap Waktu",
      level: "Level",
      stage: "Tahap",
      message: "Pesan",
      loadingLogs: "Memuat log...",
      noLogs: "Tidak ada log ditemukan."
    },
    buttons: {
      saveMetadata: 'Simpan Metadata',
      retract: 'Tarik Kembali',
      ingest: 'Proses'
    },
    notifications: {
      loadError: 'Gagal memuat detail file.',
      validationError: 'Nama File dan Penulis wajib diisi.',
      saveSuccess: 'Metadata berhasil diperbarui.',
      saveError: 'Gagal menyimpan metadata.',
      tokenError: 'Token otentikasi tidak ditemukan di data pengguna.',
      viewError: 'Tidak dapat memuat file untuk ditampilkan.',
      ingestSuccess: 'File telah berhasil dimasukkan antrian untuk diproses.',
      ingestError: 'Gagal memulai proses ingest.',
      retractSuccess: 'File telah berhasil ditarik kembali.',
      retractError: 'Gagal menarik kembali file.',
      deleteSuccess: 'File berhasil dihapus.',
      deleteError: 'Gagal menghapus file.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Harap pilih setidaknya satu label sebelum memproses.",
      ingestSaving: "Menyimpan metadata sebelum pemrosesan...",
      ingestSaveFailed: "Gagal menyimpan metadata. Pemrosesan dibatalkan.",
      logError: "Gagal mengambil log pemrosesan.",
      killDocSent: "Permintaan penghentian untuk dokumen ini telah dikirim.",
      killProcSent: "Permintaan penghentian untuk proses pemrosesan telah dikirim."
    },
    confirm: {
      ingest: 'Apakah Anda yakin ingin memproses file ini? Ini akan memulai alur pemrosesan data.',
      retract: 'Apakah Anda yakin ingin menarik kembali file ini?',
      delete: 'Apakah Anda yakin ingin menghapus file ini secara permanen? Tindakan ini tidak dapat dibatalkan.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Konfirmasi Pemrosesan",
      retractTitle: "Konfirmasi Penarikan",
      deleteTitle: "Konfirmasi Penghapusan",
      killDocTitle: "Hentikan Pemrosesan Dokumen",
      killDoc: "Apakah Anda yakin ingin menghentikan tugas pemrosesan untuk DOKUMEN INI? Proses akan mencoba pembatalan yang aman.",
      killProcTitle: "Hentikan SELURUH Proses Pemrosesan",
      killProc: "PERINGATAN: Ini akan menghentikan seluruh layanan pemrosesan backend, mempengaruhi SEMUA file yang sedang diproses. Apakah Anda benar-benar yakin?"
    }
  },
  uploadDialog: {
    title: 'Unggah File',
    dropzone: 'Seret & lepas file di sini, atau klik untuk memilih',
    allowedTypesLabel: 'Tipe yang diizinkan:',
    buttonUpload: 'Unggah {count} File', // Pluralization might need adjustment for Indonesian rules
    remove: 'Hapus',
    uploading: 'Mengunggah...',
    notifications: {
      dropError: 'Hanya file yang bisa dilepaskan. Harap periksa apakah Anda menyeret file yang valid dari komputer Anda.',
      typeNotAllowed: 'Tipe file "{extension}" tidak diizinkan.',
      shortcutUnsupported: 'File pintasan (.url) tidak didukung. Harap seret file yang sebenarnya.',
      duplicate: 'File "{fileName}" sudah ditambahkan.',
      uploadSuccess: 'Berhasil mengunggah {fileName}',
      uploadFailed: 'Gagal mengunggah {fileName}.'
    }
  }
}